<template>
    <div class="fill-height of-y d-flex flex-column">
        <div class="flex-grow-0 pa-2 d-flex align-center justify-space-between">
            <div>
                <v-btn
                        :disabled="false"
                        @click="exportReportData"
                        color="primary"
                        small
                        :loading="exportingData"
                >
                    Export
                </v-btn>
              
              <v-btn
                  :disabled="false"
                  @click="exportPickedData"
                  color="primary"
                  small
                  :loading="exportingData"
                  class="ml-2"
              >
                Export Captured Bins
              </v-btn>
            </div>
            <div style="width: 30%">
                <v-text-field
                        v-model="search"
                        prepend-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                        class="pa-0 ma-0"
                ></v-text-field>
            </div>
        </div>
        <div class="flex-grow-1 of-y">
            <v-data-table
                    :search="search"
                    dense
                    fixed-header
                    height="100%"
                    class="fill-height of-y"
                    hide-default-footer
                    :headers="headers"
                    :items="rows"
                    :options="{itemsPerPage: rows.length}"
            ></v-data-table>
        </div>
    </div>
</template>

<script>

import {mapGetters} from "vuex";
import {format} from "date-fns";

export default {
    components: {},
    props: {
        data: Array,
        reportType: String,
        selectedFarm: Number,
        selectedDate: Date,
    },
    data() {
        return {
            exportingData: false,
            search: null,
            headers: [
                {text: "Farm", value: "farm"},
                {text: "Present Emps", value: "presentEmployees"},
                {text: "Absent Emps", value: "absentEmployees"},
                {text: "Clockings", value: "clockings"},
                {text: "Bins", value: "bins"},
                {text: "PW Jobs", value: "totalPWJobs"},
                {text: "PW Units", value: "totalPWUnits"},
            ],
        }
    },
    watch: {},
    methods: {

        exportReportData() {
            this.exportingData = true;
            this.$newReqDownloadFile(
                    'POST',
                    `reports/farmSummary/export`,
                    {
                        start: this.selectedDate,
                        farms: this.selectedFarm ? [this.selectedFarm] : this.availableFarmIDs,
                    },
                    `Farm Summary ${format(this.selectedDate, 'yyyy-MM-dd')}.xlsx`
            )
                    .then(data => {
                        console.log(data)
                    })
                    .catch(e => {
                        console.log(e)
                        this.$snack.netWorkError();
                    })
                    .finally(() => {
                        this.exportingData = false
                    })
        },
      
      exportPickedData() {
        this.exportingData = true;
        this.$newReqDownloadFile(
            'POST',
            `reports/capturedBinsSummary/export`,
            {
              start: this.selectedDate,
              farms: this.selectedFarm ? [this.selectedFarm] : this.availableFarmIDs,
            },
            `Captured Bins ${format(this.selectedDate, 'yyyy-MM-dd')}.xlsx`
        )
            .then(data => {
              console.log(data)
            })
            .catch(e => {
              console.log(e)
              this.$snack.netWorkError();
            })
            .finally(() => {
              this.exportingData = false
            })
      }

    },
    computed: {
        ...mapGetters(["availableFarms", "farms", "availableFarmIDs"]),
        rows() {
            return this.data.map(row => {
                return {
                    farmID: row.farmID,
                    farm: row.farmRef.description,
                    clockings: row.clockings,
                    presentEmployees: row.presentEmployees,
                    absentEmployees: row.absentEmployees,
                    bins: row.bins,
                    totalPWJobs: row.totalPWJobs,
                    totalPWUnits: row.totalPWUnits,
                }
            })
                    .filter((row) => this.selectedFarm ? row.farmID === this.selectedFarm : true)
                    .filter(row => this.availableFarmIDs.includes(row.farmID))
        }
    },
}
</script>

<style scoped>

</style>